import {
  Box,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Zoom,
} from "@material-ui/core";
import { Close, ThumbDownAlt, ThumbUpAlt, Update } from "@material-ui/icons";
import { useAuth, useVerifyPermission } from "@airborne/react-admin";
import * as React from "react";
import { FC, Fragment, useState } from "react";
import {
  Button,
  Datagrid,
  ExportButton,
  FormDataConsumer,
  FunctionField,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
  required,
  useNotify,
  useRefresh,
} from "react-admin";
import { DetailButton } from "../../../Components/DetailButton";
import { ConfirmButton } from "../../../Components/ConfirmButton";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../Constants/Constant";
import { useAppDataProvider } from "../../../dataprovider";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { TabbedDatagridProps } from "../../../Models/TabbedDataGridProps";
import { SourceReliabilityFailOnFit } from "./Constants";
import { Form } from "react-final-form";
import {
  ReliabilityFoFRejectReasonType,
  ReliabilityFofReasonChoices,
  ReliabilityFofReasonType,
  ReliabilityNotFoFReasonType,
} from "../../../../src/Enums/ReliabilityFofReasonType";
import { ReliabilityFailOnFitUpdateModel } from "../Models/ReliabilityFailOnFitModel";
import { ReliabilityFoFChoices, ReliabilityFofStatus } from "../.././../../src/Enums/ReliabilityFoFStatus";
import { EnumField } from "../../../../src/Components/EnumField";
import RefNoUrlField from "../../../Components/LinkButton/RefNoUrlField";
import { ReliabilityAfterPoolVendorTypeChoices } from "../../../Enums/ReliabilityAfterPoolVendorType";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";
import { ReliabilityBeforePoolVendorTypeChoices } from "../../../../src/Enums/ReliabilityBeforePoolVendorType";
import { formatDate } from "../../../Helper/MomentHelper";

const cdmCategoryServiceEndpoint = "cdmservicelevel";

const TabbedDatagrid: FC<TabbedDatagridProps> = props => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const { user } = useAuth();
  const refresh = useRefresh(); 

  const AcceptFailOnFitButton = props => {
    const acceptButtonClick = record => e => {
      let reliabilityFailOnFit: ReliabilityFailOnFitUpdateModel = new ReliabilityFailOnFitUpdateModel();
      reliabilityFailOnFit.Id = record?.id;
      reliabilityFailOnFit.RequestOrderId = record?.requestOrderId;
      reliabilityFailOnFit.RequestType = record?.requestType;
      reliabilityFailOnFit.ReportId = record?.reportId;
      reliabilityFailOnFit.BeforePoolOrderType = record?.beforePoolOrderType;
      reliabilityFailOnFit.BeforePoolOrderNumber = record?.beforePoolOrderNumber;
      reliabilityFailOnFit.BeforePoolOrderStatus = record?.beforePoolOrderStatus;
      reliabilityFailOnFit.BeforePoolVendorType = record?.beforePoolVendorType;
      reliabilityFailOnFit.BeforePoolVendor = record?.beforePoolVendor;
      reliabilityFailOnFit.BeforePoolCondition = record?.beforePoolCondition;
      reliabilityFailOnFit.AfterPoolOrderType = record?.afterPoolOrderType;
      reliabilityFailOnFit.AfterPoolOrderNumber = record?.afterPoolOrderNumber;
      reliabilityFailOnFit.AfterPoolOrderStatus = record?.afterPoolOrderStatus;
      reliabilityFailOnFit.AfterPoolVendorType = record?.afterPoolVendorType;
      reliabilityFailOnFit.AfterPoolVendor = record?.afterPoolVendor;
      reliabilityFailOnFit.AfterPoolCondition = record?.afterPoolCondition;
      reliabilityFailOnFit.FofStatus = ReliabilityFofStatus.Confirmed;

      dataProvider
        .putReliabilityFailOnFit(reliabilityFailOnFit)
        .then(result => {
          notify(`Reliability Fail On Fit Updated`, "success", false, true);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{ width: 40, color: "#12824C" }}
        size="medium"
        click={acceptButtonClick(props?.record)}
      >
        <Tooltip TransitionComponent={Zoom} title="Accept Fail On Fit">
          <ThumbUpAlt />
        </Tooltip>
      </ConfirmButton>
    );
  };

  const RejectFailOnFitButton = props => {
    const [open, setOpen] = useState(false);

    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const RejectReliabilityFofButtonClick = props => e => {
      let reliabilityFailOnFit: ReliabilityFailOnFitUpdateModel = new ReliabilityFailOnFitUpdateModel();
      reliabilityFailOnFit.Id = props?.record?.id;
      reliabilityFailOnFit.RequestOrderId = props?.record?.requestOrderId;
      reliabilityFailOnFit.RequestType = props?.record?.requestType;
      reliabilityFailOnFit.ReportId = props?.record?.reportId;
      reliabilityFailOnFit.BeforePoolOrderType = props?.record?.beforePoolOrderType;
      reliabilityFailOnFit.BeforePoolOrderNumber = props?.record?.beforePoolOrderNumber;
      reliabilityFailOnFit.BeforePoolOrderStatus = props?.record?.beforePoolOrderStatus;
      reliabilityFailOnFit.BeforePoolVendorType = props?.record?.beforePoolVendorType;
      reliabilityFailOnFit.BeforePoolVendor = props?.record?.beforePoolVendor;
      reliabilityFailOnFit.BeforePoolCondition = props?.record?.beforePoolCondition;
      reliabilityFailOnFit.AfterPoolOrderType = props?.record?.afterPoolOrderType;
      reliabilityFailOnFit.AfterPoolOrderNumber = props?.record?.afterPoolOrderNumber;
      reliabilityFailOnFit.AfterPoolOrderStatus = props?.record?.afterPoolOrderStatus;
      reliabilityFailOnFit.AfterPoolVendorType = props?.record?.afterPoolVendorType;
      reliabilityFailOnFit.AfterPoolVendor = props?.record?.afterPoolVendor;
      reliabilityFailOnFit.AfterPoolCondition = props?.record?.afterPoolCondition;
      reliabilityFailOnFit.FofStatus = ReliabilityFofStatus.Rejected;
      reliabilityFailOnFit.Reason = e.reason;
      reliabilityFailOnFit.OtherReason = e.otherReason;

      dataProvider
        .putReliabilityFailOnFit(reliabilityFailOnFit)
        .then(result => {
          notify(`Reliability Fail On Fit Updated`, "success", false, true);
          setOpen(false);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <IconButton {...props} style={{ width: 40 }} onClick={handleClick}>
          <Tooltip TransitionComponent={Zoom} title="Reject Fail On Fit">
            <ThumbDownAlt />
          </Tooltip>
        </IconButton>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Reject Fail On Fit</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={RejectReliabilityFofButtonClick(props)}
              render={({ handleSubmit }) => (
                <form>
                  <Grid container>
                    <Grid item xs={12}>
                      <SelectInput
                        source="reason"
                        label="Reject Reason"
                        choices={ReliabilityFoFRejectReasonType}
                        optionText="key"
                        optionValue="value"
                        validate={required()}
                        fullWidth
                        variant="outlined"
                      />
                      <FormDataConsumer>
                        {({ formData, ...rest }) =>
                          formData.reason === ReliabilityFofReasonType.Other && (
                            <TextInput
                              source="otherReason"
                              label="Other Reason"
                              fullWidth
                              variant="outlined"
                              multiline
                              {...rest}
                            />
                          )
                        }
                      </FormDataConsumer>
                    </Grid>
                    <Grid item xs={12}>
                      <Button label={"Reject On Fit"} size="large" variant="contained" onClick={handleSubmit}>
                        <Update />
                      </Button>
                      <Button label={"Cancel!"} size="large" variant="contained" onClick={ClosePopup} color="secondary">
                        <Update />
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const NotFailOnFitButton = props => {
    const [open, setOpen] = useState(false);

    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const ReliabilityNotFofButtonClick = props => e => {
      let reliabilityFailOnFit: ReliabilityFailOnFitUpdateModel = new ReliabilityFailOnFitUpdateModel();
      reliabilityFailOnFit.Id = props?.record?.id;
      reliabilityFailOnFit.RequestOrderId = props?.record?.requestOrderId;
      reliabilityFailOnFit.RequestType = props?.record?.requestType;
      reliabilityFailOnFit.ReportId = props?.record?.reportId;
      reliabilityFailOnFit.BeforePoolOrderType = props?.record?.beforePoolOrderType;
      reliabilityFailOnFit.BeforePoolOrderNumber = props?.record?.beforePoolOrderNumber;
      reliabilityFailOnFit.BeforePoolOrderStatus = props?.record?.beforePoolOrderStatus;
      reliabilityFailOnFit.BeforePoolVendorType = props?.record?.beforePoolVendorType;
      reliabilityFailOnFit.BeforePoolVendor = props?.record?.beforePoolVendor;
      reliabilityFailOnFit.BeforePoolCondition = props?.record?.beforePoolCondition;
      reliabilityFailOnFit.AfterPoolOrderType = props?.record?.afterPoolOrderType;
      reliabilityFailOnFit.AfterPoolOrderNumber = props?.record?.afterPoolOrderNumber;
      reliabilityFailOnFit.AfterPoolOrderStatus = props?.record?.afterPoolOrderStatus;
      reliabilityFailOnFit.AfterPoolVendorType = props?.record?.afterPoolVendorType;
      reliabilityFailOnFit.AfterPoolVendor = props?.record?.afterPoolVendor;
      reliabilityFailOnFit.AfterPoolCondition = props?.record?.afterPoolCondition;
      reliabilityFailOnFit.FofStatus = ReliabilityFofStatus.NotFof;
      reliabilityFailOnFit.Reason = e.reason;
      reliabilityFailOnFit.OtherReason = e.otherReason;

      dataProvider
        .putReliabilityFailOnFit(reliabilityFailOnFit)
        .then(result => {
          notify(`Reliability Fail On Fit Updated`, "success", false, true);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <IconButton {...props} style={{ width: 40, color: "red" }} onClick={handleClick}>
          <Tooltip TransitionComponent={Zoom} title="Not Fail On Fit">
            <Close />
          </Tooltip>
        </IconButton>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Not Fail On Fit</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={ReliabilityNotFofButtonClick(props)}
              render={({ handleSubmit }) => (
                <form>
                  <Grid container>
                    <Grid item xs={12}>
                      <SelectInput
                        source="reason"
                        label="Not Fof Reason"
                        choices={ReliabilityNotFoFReasonType}
                        optionText="key"
                        optionValue="value"
                        validate={required()}
                        fullWidth
                        variant="outlined"
                      />

                      <FormDataConsumer>
                        {({ formData, ...rest }) =>
                          formData.reason === ReliabilityFofReasonType.Other && (
                            <TextInput
                              source="otherReason"
                              label="Other Reason"
                              fullWidth
                              variant="outlined"
                              multiline
                              {...rest}
                            />
                          )
                        }
                      </FormDataConsumer>
                    </Grid>
                    <Grid item xs={12}>
                      <Button label={"Not Fail On Fit"} size="large" variant="contained" onClick={handleSubmit}>
                        <Update />
                      </Button>
                      <Button label={"Cancel!"} size="large" variant="contained" onClick={ClosePopup} color="secondary">
                        <Update />
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const DetailsButton = ({ record }) => {
    return <DetailButton record={record} resource={SourceReliabilityFailOnFit} />;
  };

  const OptButtonGroup = ({ record }) => {
    return (
      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          <DetailsButton record={record} />
          {user?.isCustomer === false && (
            <>
              <AcceptFailOnFitButton record={record} />
              <RejectFailOnFitButton record={record} />
              <NotFailOnFitButton record={record} />
            </>
          )}
        </ButtonGroup>
      </Box>
    );
  };

  return (
    <Fragment>
      <Datagrid optimized basePath={SourceReliabilityFailOnFit}>
        <OptButtonGroup record={props} />
        <RefNoUrlField source="refNo" label="Ref No" />
        <TextField source="ownerCode" label="Customer" />
        <TextField source="requirementCategoryText" label="Category" />
        <TextField source="ac" label="AC Reg" />
        <FunctionField
          label="Request Date"
          sortBy="createdDate"
          render={(record: any) => {
            return record.createdDate === null ? null : formatDate(record.createdDate);
          }}
        />
        <TextField source="pn" label="Pn" />
        <TextField source="sn" label="Sn" />
        <TextField source="pnDescription" label="Pn Description" />
        {!user?.isCustomer && <TextField source="beforePoolVendorType" label="Before Pool Vendor Type" />}
        {!user?.isCustomer && <TextField source="afterPoolVendorType" label="After Pool Vendor Type" />}
        <EnumField label={"Fof Status"} enumName={"ReliabilityFofStatus"} source={"fofStatus"} />
        <EnumField label={"Reason"} enumName={"ReliabilityFofReasonType"} source={"reason"} />
      </Datagrid>
    </Fragment>
  );
};

const FailOnFitList = props => {
  useVerifyPermission("customroutes", "reliabilityfailonfits.read");
  const { user } = useAuth();

  const ListActions = props => {
    return (
      <TopToolbar {...props}>
        <ExportButton
          resource={props.resource}
          sort={props.currentSort}
          filterValues={props.filterValues}
          maxResults={10000}
        />
      </TopToolbar>
    );
  };

  const exporter = (records, fetchRelatedRecords) => {
    // will call dataProvider.getMany('cdmaircrafts', { ids: records.map(record => record.aircraftId) }), ignoring duplicate and empty aircraftId
    fetchRelatedRecords(records, "requirementCategory", cdmCategoryServiceEndpoint).then(serviceLevel => {
      const data = records.map(record => {
        const mappedRecord = {
          //...record,
          "Ref No": record.refNo,
          Customer: record.ownerCode,
          Category: serviceLevel[record.requirementCategory]?.category,
          "Ac Reg": record.ac,
          "Request Date": record.createdDate,
          Pn: record.pn,
          Sn: record.sn,
          Chapter: record.chapter,
          "Pn Description": record.pnDescription,
          "Fof Status": ReliabilityFoFChoices.find(x => x.value === record.fofStatus)?.key,
          Reason: ReliabilityFofReasonChoices.find(x => x.value === record.reason)?.key,
          "After Pool Order Type": record.afterPoolOrderType,
          "After Pool Order Number": record.afterPoolOrderNumber,
          "After Pool Order Status": record.afterPoolOrderStatus,
          "After Pool Vendor Type": record.afterPoolVendorType,
          "After Pool Vendor": record.afterPoolVendor,
          "After Pool Condition": record.afterPoolCondition,
          "Reliability Report Created Date": record.reliabilityReportCreatedDate,
        };

        // Non Customer fields
        if (!user?.isCustomer) {
          mappedRecord["Before Pool Order Type"] = record.beforePoolOrderType;
          mappedRecord["Before Pool Order Number"] = record.beforePoolOrderNumber;
          mappedRecord["Before Pool Order Status"] = record.beforePoolOrderStatus;
          mappedRecord["Before Pool Vendor Type"] = record.beforePoolVendorType;
          mappedRecord["Before Pool Vendor"] = record.beforePoolVendor;
          mappedRecord["Before Pool Condition"] = record.beforePoolCondition;
          mappedRecord["Sub Category"] = record.subCategory;
        }

        return mappedRecord;
      });

      const columns = Object.keys(data[0]).map(record => ({ header: record }));

      ExcelExport(columns, data, "Fail on Fit List");
    });
  };

  const fofChoices = [{ key: "ALL" }, ...ReliabilityFoFChoices];

  const ttFilters = [
    <TextInput label="Ref No" source="refNo__contains" alwaysOn />,
    <TextInput label="Ac Reg" source="ac__contains" alwaysOn />,
    <TextInput label="Pn" source="pn__contains" alwaysOn />,
    <TextInput label="Sn" source="sn__contains" alwaysOn />,
    <TextInput label="Pn Description" source="pnDescription__contains" alwaysOn />,
    <SelectInput
      label="Before Pool Vendor Type"
      source="beforePoolVendorType__eq"
      choices={ReliabilityBeforePoolVendorTypeChoices}
      optionValue="key"
      optionText="key"
      allowEmpty
      emptyText="ALL"
      alwaysOn
    />,
    <SelectInput
      label="After Pool Vendor Type"
      source="afterPoolVendorType__eq"
      choices={ReliabilityAfterPoolVendorTypeChoices}
      optionValue="key"
      optionText="key"
      allowEmpty
      emptyText="ALL"
      alwaysOn
    />,
    <SelectInput
      label="FoF Status"
      source="fofStatus__eq"
      choices={fofChoices}
      optionValue="value"
      optionText="key"
      alwaysOn
    />,
  ];

  const customerFilters = [
    <TextInput label="Ref No" source="refNo__contains" alwaysOn />,
    <TextInput label="Ac Reg" source="ac__contains" alwaysOn />,
    <TextInput label="Pn" source="pn__contains" alwaysOn />,
    <TextInput label="Sn" source="sn__contains" alwaysOn />,
    <TextInput label="Pn Description" source="pnDescription__contains" alwaysOn />,
    <SelectInput
      label="FoF Status"
      source="fofStatus__eq"
      choices={fofChoices}
      optionValue="value"
      optionText="key"
      alwaysOn
    />,
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <PoolList
          {...props}
          hasCreate={false}
          exporter={exporter}
          actions={<ListActions />}
          bulkActionButtons={false}
          resource={SourceReliabilityFailOnFit}
          title={"Fail On Fit List"}
          sort={DefaultCreatedDateSort}
          perPage={DefaultPerPageSize}
          filters={!user?.isCustomer ? ttFilters : customerFilters}
          filter={props?.filterParams}
        >
          <TabbedDatagrid />
        </PoolList>
      </Grid>
    </Grid>
  );
};

export default FailOnFitList;
